import React, { useMemo } from 'react';
import _get from 'lodash/get';
import CollectionMapping from './CollectionMapping';
import _MAPPING_PRESETS, { CollectionItem } from './MAPPING_PRESETS';

export const MAPPING_PRESETS = _MAPPING_PRESETS;

interface Props {
  mapping: any;
  value: string;
  onChange: (newMapping: any) => void;
  flexDirection?: 'row' | 'column';
}

export default function CollectionMappingContainer(props: Props) {
  const { mapping, value } = props;
  const rootKey = value.split('.')[0];

  const collectionMapping = useMemo(() => {
    return MAPPING_PRESETS.find((mp: CollectionItem) => mp.key === rootKey);
  }, [rootKey]) as CollectionItem;

  if (!collectionMapping) {
    return null;
  }

  const subSource = getSubSource({ collectionMapping, mapping });
  const defaultType = collectionMapping.types.find(i => i.isDefault);

  const collectionItemType = mapping.collectionItemType
    ? mapping.collectionItemType
    : defaultType
    ? defaultType.key
    : _get(collectionMapping, 'types[0]', '');

  return (
    <CollectionMapping
      {...props}
      subSource={subSource}
      collectionMapping={collectionMapping}
      collectionItemType={collectionItemType}
      collectionItemCustomType={mapping.collectionItemCustomType || ''}
      rootKey={rootKey}
    />
  );
}

function getSubSource({ collectionMapping, mapping }: any) {
  const defaultSubSource = collectionMapping.itemProperties.find(
    (i: { key: string; isDefault: boolean }) => !!i.isDefault,
  );

  return (
    _get(mapping, `customProps.subSource`) ||
    mapping.source.split('.')[1] ||
    _get(defaultSubSource, 'key') ||
    ''
  );
}
